"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _tinymce = _interopRequireDefault(require("tinymce"));

var _LineHeightMenu = _interopRequireDefault(require("rich-text-lib/components/formatting/LineHeightMenu"));

var _formatting = require("../../utils/formatting");

var _hsformatting = require("../../constants/hsformatting");

var TinyMceLineHeight =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TinyMceLineHeight, _Component);

  function TinyMceLineHeight(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TinyMceLineHeight);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TinyMceLineHeight).call(this, props));
    _this.state = {
      value: null
    };
    _this.handleNodeChange = _this.handleNodeChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.valueMatcher = (0, _formatting.getMatchingValueHandler)(_this.props.editor, _hsformatting.LINE_HEIGHT_FORMAT, _this.props.lineHeights);
    return _this;
  }

  (0, _createClass2.default)(TinyMceLineHeight, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var editor = this.props.editor;
      editor.on('NodeChange', this.handleNodeChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var editor = this.props.editor;
      editor.off('NodeChange', this.handleNodeChange);
    }
  }, {
    key: "handleNodeChange",
    value: function handleNodeChange(e) {
      var currentControlValue = this.state.value;
      var newControlValue = this.valueMatcher(e) || currentControlValue;

      if (currentControlValue === newControlValue) {
        return;
      }

      this.setState({
        value: newControlValue
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          lineHeights = _this$props.lineHeights,
          tooltip = _this$props.tooltip;
      var value = this.state.value;
      return _react.default.createElement(_LineHeightMenu.default, {
        dropdownClassName: "mce-hubspot-menu",
        tooltip: tooltip,
        options: lineHeights,
        lineHeight: value,
        onChange: this.props.onChange
      });
    }
  }]);
  return TinyMceLineHeight;
}(_react.Component);

exports.default = TinyMceLineHeight;
TinyMceLineHeight.propTypes = {
  editor: _react.PropTypes.instanceOf(_tinymce.default.Editor),
  onChange: _react.PropTypes.func.isRequired,
  lineHeights: _react.PropTypes.array.isRequired,
  tooltip: _react.PropTypes.string.isRequired
};
module.exports = exports.default;